module.exports = __webpack_public_path__ + "img/liwu2.73bb3efc.png";